import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import ParentContentCard from '../common/ParentContentCard';
import { correctNameFormat } from '../../common/utils/data_source-util';

export class CreateCollectionWithPostgresql extends Component {
  static propTypes = {
    collections: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  handleCancel = () => {
    const { match, history } = this.props;
    const { projectId, version } = match.params;
    history.push(`/collections/${version}/v/${projectId}/create`);
  };

  render() {
    const { match } = this.props;
    const { dataSourceName } = match.params;
    const correctName = correctNameFormat(dataSourceName);
    return (
      <CommonPageComponent parentClassName="">
        <ParentContentCard
          title={`Create Collection via ${correctName}`}
          datasourceIconSvg={dataSourceName}
        >
          <h3 className="text-center">
            This Feature is supported in <b style={{ color: '#344767' }}>Enterprise Plan</b>.<br />
            Please&nbsp;
            <a href="https://drapcode.com/contact-us" target="_blank">
              contact us
            </a>
            &nbsp;on&nbsp;
            <a href="mailto:support@drapcode.com">support@drapcode.com</a> for more details.
          </h3>
          <div className="clearfix">
            <button
              className="btn btn-outline-secondary"
              title="Cancel"
              type="button"
              onClick={this.handleCancel}
            >
              <i className="wb webconnect-times"></i> Back
            </button>
            <a
              href="https://drapcode.com/contact-us"
              className="btn btn-theme-submit float-right btn-md"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="wb webconnect-box-arrow-up-right"></i>&nbsp;Contact Us&nbsp;
            </a>
          </div>
        </ParentContentCard>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    collections: state.collections,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateCollectionWithPostgresql);
